<template>
    <div class="list-result-container">
        <div class="list-result container">
            <div class="row gx-3 mt-2">
                <div class="col-6 col-md-3 mb-4" v-for="index in count" :key="index">
                    <div class="campaign-item campaign-item-slider">
                        <div
                            class="campaign-item-cover animated-background">
                        </div>

                        <div class="campaign-item-logo animated-background" style="width: 95px; height: 95px;border: 2px solid #fff;">
                        </div>

                        <div class="campaign-item-heading">
                            <!-- <p class="card-text"> -->
                            <div style="width: 150px; height: 8px; margin: 15px 0px;" class="animated-background"></div>

                            <div style="width: 150px; height: 8px; margin: 15px 0px;" class="animated-background"></div>
                            <!-- </p> -->
                        </div>

                        <div class="campaign-item-action">
                            <div style="height: 39px; width: 150px; border-radius: 5px;" class="animated-background"></div>
                            <!-- <button class="btn btn-outline-dark "> {{ $t('to_the_deal') }} </button> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            count: { default: 8 }
        }
    }
</script>
